import moment from 'moment';

export function date(dateValue, format = 'DD/MM/Y', isBirthDate) {
  if(isBirthDate){
    const formattedDate = dateValue &&
    dateValue.toString().length > 10 ? 
    dateValue.toString().slice(0, 10) : dateValue;
    return moment(formattedDate).format(format);
  }
  return moment(dateValue).format(format)
}
export function time(dateValue, format = 'H:m') {
  return moment(dateValue).format(format)
}
export function fullDate(dateValue, format = 'DD MMM YYYY, HH:mm') {
  return moment(dateValue).format(format)
}

export function getHumanized(dateValue) {
  return date(dateValue, 'ddd, MMM Do');
}

export function add(_date, count, intervals) {
  return moment(_date === null ? moment() : _date).add(count, intervals);
}

export function year(_date = null) {
  if (!_date) {
    return moment().year();
  }

  return moment(_date).year();
}

export function expiryDate(dateValue) {
  return date(dateValue, 'MM/YYYY');
}

export function toApiDate(dateValue, fromFormat = 'DD/MM/YYYY') {
  return moment(dateValue, fromFormat).format('YYYY-MM-DD');
}

/**
 * TODO: Return greeting by time
 */
export function getGreeting() {
  const today = new Date()
  const curHr = today.getHours()

  if (curHr < 12) {
    return 'Good morning';
  } if (curHr < 18) {
    return 'Good afternoon';
  }

  return 'Good evening';
}


export default {
  date,
  time,
  fullDate,
  getHumanized,
  add,
  expiryDate,
  toApiDate,
  getGreeting,
  year
}
